import React, { useState } from "react";
import "../../assets/css/grid.scss";
import "../../assets/css/style.scss";
import logo from '../../assets/images/logo.png';
import { Link } from "react-router-dom";
import * as userApis from "apis/users";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState(""); // unified error
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email.trim()) {
      setError("Please enter your email address.");
      return;
    }

    setLoading(true);
    setError("");
    setSuccess("");

    try {
      await userApis.forgotPassword({ email });

      setSuccess("Reset instructions sent to your email.");
    } catch (err) {
      const errorMessage =
        err.response?.data?.message || "Something went wrong. Please try again.";
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="App">
      <div className="col-lg-100 col-md-100 col-sm-100 full-height pt-40">
        <div className="login pt-40">
          <div className="logo">
            <img src={logo} alt="Logo" />
          </div>

          <div className="login-title">
            <h1>Forgot password?</h1>
            <h6>No worries, we'll send reset instructions to your email.</h6>
          </div>

          <form className="login-form" onSubmit={handleSubmit}>
            <div className="login-input">
              <label>Email address</label>
              <input
                type="email"
                placeholder="Email address"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            {error && (
              <div className="errors">
                <h1>{error}</h1>
              </div>
            )}

            {success && (
              <div className="success">
                <h6 style={{ color: 'green' }}>{success}</h6>
              </div>
            )}

            <div className="login-input">
              <button type="submit" disabled={loading}>
                {loading ? "Sending..." : "Send"}
              </button>
            </div>
          </form>

          <div className="login-footer">
            <p>
              Don't have an account? <Link to="/Plans#plans">Signup for free</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
